<div [ngClass]="isCurrentTab == tabs.Metrics ? 'tab-pane fade show active' : 'tab-pane fade'"  id="metrics-tab-pane" role="tabpanel" aria-labelledby="metrics-tab" tabindex="0">
  <div [hidden]="!metrics.length && showForm" class="table-responsive tab-table data-management-table">
    <table *ngIf="metrics.length" aria-describedby="This table describes the metric information" class="table table-hover">
      <thead class="metrics-header">
        <tr>
          <th class="serialNo-header">S.No</th>
          <th class="firstName-header">Metrics
            <mat-icon *ngIf="sortMetricNameAsc" (click)="sortMetricNameAsc=false; getMetrics('metricName','asc')">arrow_upward</mat-icon>
            <mat-icon *ngIf="!sortMetricNameAsc" (click)="sortMetricNameAsc=true; getMetrics('metricName','desc')">arrow_downward</mat-icon>
           </th>
           <th class="firstName-header">Analytics Toolkit
            <mat-icon *ngIf="sortSubcategoryNameAsc" (click)="sortSubcategoryNameAsc=false; getMetrics('subCategoryName','asc')">arrow_upward</mat-icon>
            <mat-icon *ngIf="!sortSubcategoryNameAsc" (click)="sortSubcategoryNameAsc=true; getMetrics('subCategoryName','desc')">arrow_downward</mat-icon>
           </th>
          <th class="action-header">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let metric of metrics; index as i">
          <td>{{i+1}}</td>
          <td><p class="mat-account-detail w350 mb-0" [matTooltip]="metric.metricName!">{{metric.metricName}}</p></td>
          <td><span class="badge fs-12">{{metric.subCategoryName}}</span></td>
          <td>
            <div class="d-flex align-items-start">
              <div class="form-check form-switch package-switch me-1">
                <input class="form-check-input" type="checkbox" role="switch" (click)="activateDeactivateMetric(metric)" [(ngModel)]="metric.status" id="flexSwitchCheckDefault">
                <label class="form-check-label fs-12 mt-1" [ngClass]="!metric.status ? 'text-muted' : 'theme-text'" for="flexSwitchCheckDefault">{{metric.status ? "Active" : "Inactive"}}</label>
              </div>
              <a (click)="patchForm(metric)" class="btn-action" matTooltip="Edit details"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
                  stroke="#4F6681" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M9.90845 4.20837C10.2668 6.50837 12.1334 8.26671 14.4501 8.50004" stroke="#4F6681"
                  stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M2.5 18.3334H17.5" stroke="#4F6681" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg></a>
              <a (click)="deleteMetric(metric)" class="btn-action" matTooltip="Delete details"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4999 1.5C10.9141 1.5 11.2499 1.16421 11.2499 0.75C11.2499 0.335787 10.9141 0 10.4999 0H5.49992C5.0857 0 4.74992 0.335786 4.74992 0.75C4.74992 1.16421 5.0857 1.5 5.49992 1.5L10.4999 1.5ZM1.33325 3.58333H1.44226L2.13845 13.0111L2.13849 13.0117C2.23268 14.2735 3.28338 15.25 4.54891 15.25H11.4489C12.7167 15.25 13.7689 14.2699 13.8595 13.0053L13.8595 13.0051L14.5323 3.58333H14.6666C15.0808 3.58333 15.4166 3.24755 15.4166 2.83333C15.4166 2.41912 15.0808 2.08333 14.6666 2.08333H13.8351L13.8339 2.08333H2.13891L2.13826 2.08333H1.33325C0.919038 2.08333 0.583252 2.41912 0.583252 2.83333C0.583252 3.24755 0.919038 3.58333 1.33325 3.58333ZM3.63433 12.9L2.94634 3.58333H13.0285L12.3633 12.8981C12.3289 13.3784 11.9294 13.75 11.4489 13.75H4.54891C4.06954 13.75 3.6703 13.38 3.63435 12.9003L3.63433 12.9ZM10.4166 7C10.4166 6.58579 10.0808 6.25 9.66658 6.25C9.25237 6.25 8.91658 6.58579 8.91658 7V10.3333C8.91658 10.7475 9.25237 11.0833 9.66658 11.0833C10.0808 11.0833 10.4166 10.7475 10.4166 10.3333V7ZM6.74992 6.25C7.16413 6.25 7.49992 6.58579 7.49992 7V10.3333C7.49992 10.7475 7.16413 11.0833 6.74992 11.0833C6.3357 11.0833 5.99992 10.7475 5.99992 10.3333V7C5.99992 6.58579 6.3357 6.25 6.74992 6.25Z" fill="#4F6681"/>
              </svg></a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <mat-paginator *ngIf="metrics?.length" [length]="totalRecords" [pageSize]="pageSize" [pageIndex]="pageNumber"
      (page)="changePage($event)" [pageSizeOptions]="[10, 20, 50, 100]">
   </mat-paginator>
  <div *ngIf="!metrics.length" class="noDataFound">
    <h1>{{'No Data Found'}}</h1>
  </div>
</div>
<ng-template #metricEditForm>
  <div *ngIf="showForm" [formGroup] = "metricForm">
    <h2 mat-dialog-title>Update Metric</h2>
    <button type="button" class="btn btn-link modal-close" (click)="closeCreateForm()">
      <svg
        width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6 6L18 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg></button>
      <mat-dialog-content>
        <div class="row">
          <div class="col-sm-12">
            <div class="mb-4">
                <span class="black-text fs-14 mb-1">Metric Name</span>
                <input type="text" [required]="true" formControlName="metricName" class="form-control"
                 [class.is-invalid]="metricForm.controls['metricName'].invalid && metricForm.controls['metricName'].touched"/>
                 <div *ngIf="(metricForm.controls['metricName'].invalid && metricForm.controls['metricName'].touched) || metricForm.controls['metricName'].dirty">
                   <small *ngIf="metricForm.controls['metricName'].errors?.['required']" class="text-danger fs-13">Metric Name is required</small>
                 </div>
            </div>
          </div>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <div class="row">
          <div class="col-12 text-end">
            <button type="button" class="btn theme-btn-outline px-4" (click)="closeCreateForm()">Cancel</button>
            <button type="button" class="btn theme-btn px-4 ms-3" [disabled]="metricForm.invalid" (click)="editMetric()">Update</button>
          </div>
        </div>
      </mat-dialog-actions>
  </div>
</ng-template>
